/* ============================================================
   CUSTOM: Header transparente sobre el hero  (Web Project)
   Observa el primer section dentro de #MainContent (el hero).
   Mientras el hero está en pantalla -> header transparente.
   Cuando el hero sale por arriba -> agrega .wp-header--solid.
   ============================================================ */
(function () {
  function init() {
    var wrapper = document.querySelector('.header-wrapper.wp-header--transparent');
    if (!wrapper) return;

    var main = document.getElementById('MainContent');
    var hero = main ? main.firstElementChild : null;

    // Si no hay hero detectable, dejar el header siempre sólido
    // (evita texto blanco invisible sobre fondo claro).
    if (!hero) {
      wrapper.classList.add('wp-header--solid');
      return;
    }

    var observer = null;

    function build() {
      if (observer) observer.disconnect();
      var h = wrapper.offsetHeight || 0;

      observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) {
            wrapper.classList.remove('wp-header--solid');
          } else {
            wrapper.classList.add('wp-header--solid');
          }
        },
        {
          root: null,
          // El "borde" de cambio queda justo debajo del header.
          rootMargin: '-' + h + 'px 0px 0px 0px',
          threshold: 0,
        }
      );

      observer.observe(hero);
    }

    build();

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(build, 200);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
